import { render, staticRenderFns } from "./ToDoListAssignAssigneesDialog.vue?vue&type=template&id=69c8b1a4&scoped=true"
import script from "./ToDoListAssignAssigneesDialog.vue?vue&type=script&lang=js"
export * from "./ToDoListAssignAssigneesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c8b1a4",
  null
  
)

export default component.exports